export default {
  "content": "<path d=\"M12.209 9.654l-5.256 5.28-1.26 3.387 3.426-1.245 5.224-5.247 1.417 1.411-5.381 5.407c-.104.104-.23.184-.367.234l-5.67 2.06a1.001 1.001 0 01-1.28-1.29l2.093-5.617.042-.097a1 1 0 01.186-.26l5.408-5.433 1.418 1.41z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.293 4.293a3.121 3.121 0 014.414 4.414L17.914 10.5l1.293 1.293-1.414 1.414-7-7 1.414-1.414L13.5 6.086l1.793-1.793zm3 1.414a1.122 1.122 0 00-1.586 0L14.914 7.5 16.5 9.086l1.793-1.793a1.122 1.122 0 000-1.586z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};